var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 45,
    viewBox: "0 0 63 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3265 39.3138L28.5713 22.5001L54.3265 5.68642C55.13 5.16187 56.0603 4.86417 57.019 4.8248C57.9778 4.78542 58.9293 5.00584 59.7731 5.46273C60.6169 5.91963 61.3215 6.59603 61.8125 7.42043C62.3035 8.24482 62.5627 9.18657 62.5625 10.1461V34.8541C62.5627 35.8137 62.3035 36.7554 61.8125 37.5798C61.3215 38.4042 60.6169 39.0806 59.7731 39.5375C58.9293 39.9944 57.9778 40.2148 57.019 40.1754C56.0603 40.136 55.13 39.8383 54.3265 39.3138Z",
    fill: "url(#paint0_radial_743_591)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3265 39.3138L28.5713 22.5001L54.3265 5.68642C55.13 5.16187 56.0603 4.86417 57.019 4.8248C57.9778 4.78542 58.9293 5.00584 59.7731 5.46273C60.6169 5.91963 61.3215 6.59603 61.8125 7.42043C62.3035 8.24482 62.5627 9.18657 62.5625 10.1461V34.8541C62.5627 35.8137 62.3035 36.7554 61.8125 37.5798C61.3215 38.4042 60.6169 39.0806 59.7731 39.5375C58.9293 39.9944 57.9778 40.2148 57.019 40.1754C56.0603 40.136 55.13 39.8383 54.3265 39.3138Z",
    fill: "url(#paint1_linear_743_591)",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.4375 11.4062C0.4375 5.2825 5.31431 0.3125 11.3316 0.3125H29.4809C35.4982 0.3125 40.375 5.2825 40.375 11.4062V33.5938C40.375 39.7175 35.4982 44.6875 29.4809 44.6875H11.3316C5.31431 44.6875 0.4375 39.7175 0.4375 33.5938V11.4062Z",
    fill: "url(#paint2_radial_743_591)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.875 29.1562C4.875 27.3909 5.57628 25.6979 6.82457 24.4496C8.07286 23.2013 9.7659 22.5 11.5312 22.5H29.2812C31.0466 22.5 32.7396 23.2013 33.9879 24.4496C35.2362 25.6979 35.9375 27.3909 35.9375 29.1562C35.9375 30.9216 35.2362 32.6146 33.9879 33.8629C32.7396 35.1112 31.0466 35.8125 29.2812 35.8125H11.5312C9.7659 35.8125 8.07286 35.1112 6.82457 33.8629C5.57628 32.6146 4.875 30.9216 4.875 29.1562Z",
    fill: "url(#paint3_linear_743_591)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 32.7061C30.1639 32.7061 31.0104 32.3554 31.6346 31.7313C32.2587 31.1071 32.6094 30.2606 32.6094 29.3779C32.6094 28.4953 32.2587 27.6487 31.6346 27.0246C31.0104 26.4004 30.1639 26.0498 29.2812 26.0498C28.3986 26.0498 27.5521 26.4004 26.9279 27.0246C26.3038 27.6487 25.9531 28.4953 25.9531 29.3779C25.9531 30.2606 26.3038 31.1071 26.9279 31.7313C27.5521 32.3554 28.3986 32.7061 29.2812 32.7061ZM11.5312 26.9373C10.9428 26.9373 10.3785 27.1711 9.96236 27.5872C9.54626 28.0033 9.3125 28.5676 9.3125 29.1561C9.3125 29.7445 9.54626 30.3089 9.96236 30.7249C10.3785 31.141 10.9428 31.3748 11.5312 31.3748H20.4062C20.9947 31.3748 21.559 31.141 21.9751 30.7249C22.3912 30.3089 22.625 29.7445 22.625 29.1561C22.625 28.5676 22.3912 28.0033 21.9751 27.5872C21.559 27.1711 20.9947 26.9373 20.4062 26.9373H11.5312Z",
    fill: "#BABAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_743_591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.4088 1.20254) rotate(72.275) scale(44.7194 115.727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081,
    stopColor: "#F08AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#9C6CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E44DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_743_591",
    x1: 33.7188,
    y1: 22.5001,
    x2: 62.5226,
    y2: 21.3907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#312A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312A9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_743_591",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.82225 2.16294) rotate(45.6253) scale(65.7039 138.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#9C6CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E44DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_743_591",
    x1: 4.16944,
    y1: 22.5,
    x2: 8.54925,
    y2: 40.3609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B148A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B20A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/IconVideo.398c2af2e5f6b496ca736c7e9d6c2ed2.svg";
export { ForwardRef as ReactComponent };